import React, { Component } from 'react';

class About extends Component {
  
  render() {
    const about = (
    <section id="about-me" className="resume-section">
    <article className="container">
    <div className="row">
        <div className="category-title col-md-12">
        <div className="row">
            <div className="col-md-4">
            <h2>About Me</h2>
            </div>
        </div>
        </div>
        <div className="card-container">
        <span className="col-md-3 col-md-offset-1 side-note">Winnipeg  - April 2017</span>
        <div className="col-md-6 resume-card">
            <h3 className="title">I’m Jay,</h3>
            <p>I'm a Winnipeg based Software developer currently freelancing. I Graduated from the University of Technology Jamaica in 2011. I was previously employed to GraceKennedy Money Services Ltd.</p>

            <p>Highly motivated, hardworking, honest and reliable individual with very good work ethics. I have a very creative mind which helps me to complete tasks both efficiently and proficiently.</p>
        </div>
        </div>
    </div>
    </article>
    </section>
    );
    return (
         about
    );
  }
  
}

export default About;



// WEBPACK FOOTER //
// ./src/components/resume-components/about.js